import CreativeCard from './CreativeCard';

export default CreativeCard;
